import React from 'react';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);

export default function ConsultNowRightBottomPanel(props) {
  return (
    <div
      className="ui segment ignored info attached borderless bg-transparent before-calls-bottom"
      style={{ top: '4px' }}
    >
      <div>
        <i className="ui icon info circle mrrnull pdrxs text-size-xxl mrbm span-like" />
        <div>
          <span className="color-info">{htmlToReactParser.parse(xss(APP.LANGUAGE.ConsultNow.InfoPart))}</span>
        </div>
      </div>
    </div>
  );
}
